module.exports = __webpack_public_path__ + "img/logo_wcaworld2.f3342e95.png";